export default "/images/error_404_image.webp"